<template>
  <PageWrap>
    <ProjectsPage
      :data="data"
      :breadcrumbs="[
        {
          title: data?.page.title,
        },
      ]"
      :name="`page-${data?.page?.id}`"
    />
    <BlockFoot />
  </PageWrap>
</template>

<script setup>
const { data } = await useFetch("/api/projects");
</script>
